import { render, staticRenderFns } from "./addProductLicense.vue?vue&type=template&id=4bac5f2d&scoped=true"
import script from "./addProductLicense.vue?vue&type=script&lang=js"
export * from "./addProductLicense.vue?vue&type=script&lang=js"
import style0 from "./addProductLicense.vue?vue&type=style&index=0&id=4bac5f2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bac5f2d",
  null
  
)

export default component.exports